module.exports = __webpack_public_path__ + "img/logo.faae6efa.png";